import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { CodigoTributacaoModel } from '../../../shared/models/codigoTributacao.model';
import { CodigoTributacaoTotalModel } from '../../../shared/models/codigoTributacaoTotal.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { DeclaracaoRendimentoService } from '../service/declaracao-rendimento.service';
import { DeclaracaoRendimentoDetalhePdf } from './../../../shared/services/documentos-pdf-imprimir/financeiro/declaracao-redimento/declaracao-rendimento-detalhe-pdf';
import { FinanceiroService } from '../../service/financeiro.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../../app.constants';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';

@Component({
  selector: 'app-declaracao-rendimento-detalhe',
  templateUrl: './declaracao-rendimento-detalhe.component.html',
  styleUrls: ['./declaracao-rendimento-detalhe.component.css']
})
export class DeclaracaoRendimentoDetalheComponent implements OnInit {

  param: string;

  componentes: any[] = [1];

  codigoTributacaoTotalModel: Array<CodigoTributacaoTotalModel> = new Array<CodigoTributacaoTotalModel>();
  codigoTributacaoModel: Array<CodigoTributacaoModel> = new Array<CodigoTributacaoModel>();

  cdCentrus: number;
  // 474584
  versaoRetorno: number;
  ano: number;


  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  constructor(
    private declaracaoRendimentoService: DeclaracaoRendimentoService,
    private activatedRoute: ActivatedRoute,
    private financeiroService: FinanceiroService,
    private declaracaoRendimentoDetalhePdf: DeclaracaoRendimentoDetalhePdf,
    private authInterceptor: AuthInterceptor,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {

    this.param = '/financeiros/declaracaoRendimento';
    this._gerenciarCodigoIndentificao();

  }

  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {
        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
        }
        this.getPessoasDadosSimplificado();
      })
  }






  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getAnoCorrente();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }



  async getAnoCorrente() {

    this.ano = this.activatedRoute.snapshot.params.ano;
    this.getObterVersao(this.ano);
  }

  async getObterVersao(aaVersao: number) {
    try {
      this.versaoRetorno = await this.declaracaoRendimentoService.getObterVersao(aaVersao);
      this.getDeclRendDirfBeanObterDeclDirf();
      this.getObterDeclDirfSoma();
    } catch (error) {
      console.error(error);
    }
  }



  async getDeclRendDirfBeanObterDeclDirf() {
    try {
      this.codigoTributacaoModel = await this.financeiroService.getDeclRendDirfBeanObterDeclDirf(this.cdCentrus, this.versaoRetorno);
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 });
    }
  }


  async getObterDeclDirfSoma() {
    try {
      this.codigoTributacaoTotalModel = await this.financeiroService.getObterDeclDirfSoma(this.cdCentrus, this.versaoRetorno);
    } catch (error) {
      console.error(error);
    }
  }


  imprimirPagina(): void {
    this.declaracaoRendimentoDetalhePdf.funcionarios(this.pessoaDadosSimplicadosModel, this.ano, this.codigoTributacaoModel, this.codigoTributacaoTotalModel);
  }


  // codigoTributacaoModel
}







// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento/declaracao-rendimento-detalhe/declaracao-rendimento-detalhe.component.ts